<div class="game-score__container" *transloco="let t; prefix: 'pages.game-component'">
  @if (themeService.header().hasCloseButton) {
    <app-nav-button icon="close" (clickEvent)="onCloseClicked()" class="game-score__back-button" />
  }
  @if (gameInterfaceState() !== GameInterfaceState.GameStarted) {
    <div class="game-score__content">
      <div class="game-score__title">
        <app-game-title [gameId]="gameId()" [title]="gameName() ?? ''"></app-game-title>
      </div>
    </div>
  }
  @if (gameInterfaceState() === GameInterfaceState.GameStarted) {
    <div class="game-score__content">
      <div class="game-score__pill-content">
        <!-- Solo always shows its target block, inline-prize skins included: the target is the
             round's whole point, and the score pill below it stays as it is. -->
        @if (solo(); as round) {
          @if (round.target !== undefined) {
            <app-solo-target-progress
              [target]="round.target"
              [score]="score() ?? 0"
              [prize]="round.prize"
            />
          } @else {
            <!-- Before the target is known, so always unbeaten: once it is known
                 app-solo-target-progress draws this pill itself, since it turns lime with the
                 target. -->
            <div class="game-score__row">
              <app-mode-pill mode="solo" [label]="soloLabel" [state]="'active'">
                @if (round.prize; as prize) {
                  <app-currency-amount
                    [primaryAmount]="prize.primary"
                    [secondaryAmount]="prize.secondary"
                  />
                }
              </app-mode-pill>
            </div>
          }
        } @else if (!themeService.header().inlinePrizePill) {
          <div class="game-score__row">
            <div [ngStyle]="prizeStyles | theme" class="game-score__prize">
              @if (mode() === "tournament") {
                <app-mode-pill mode="tournament" [label]="tournamentLabel" [state]="'active'" />
              } @else {
                <span>{{ t("prize") }} </span>
                <app-currency-amount
                  [primaryAmount]="rewardAmount()"
                  [secondaryAmount]="reward()?.secondary"
                />
              }
            </div>
          </div>
        }
        <div class="game-score__row">
          @if (showScore) {
            <div class="game-pill game-pill--header" [ngStyle]="scorePillStyles | theme">
              <app-icon
                icon="points"
                colorCss="'var(--game-header-prize-fill)'"
                sizeCss="--game-header-pill-icon-size-resolved"
              ></app-icon>
              <div class="game-pill__labels">
                <div class="game-pill__score">{{ formattedScore() }}</div>
                @if (themeService.header().hasPillSubLabel) {
                  <div [ngStyle]="scorePillSubLabelStyles | theme">{{ t("score") }}</div>
                }
              </div>
            </div>
          }

          @if (primaryRewardLabel && themeService.header().inlinePrizePill && mode() === "duel") {
            <div class="game-pill" [ngStyle]="prizePillStyles | theme">
              <div class="game-pill__labels">
                <app-currency-amount
                  class="game-pill__reward"
                  [primaryAmount]="rewardAmount()"
                  [secondaryAmount]="reward()?.secondary"
                />

                @if (themeService.header().hasPillSubLabel) {
                  <div [ngStyle]="currencyPillSubLabelStyles | theme">{{ t("prize") }}</div>
                }
              </div>
            </div>
          }

          <div class="game-pill game-pill--header" [ngStyle]="timerPillStyles | theme">
            <app-icon
              icon="stopwatch"
              colorCss="'var(--game-header-prize-fill)'"
              sizeCss="--game-header-pill-icon-size-resolved"
            ></app-icon>

            <div class="game-pill__labels">
              <div class="game-pill__timer">
                <span class="game-score__stack">
                  <!-- Ghost span to reserve space -->
                  @if (countdown(); as secondsLeft) {
                    <span class="game-score__ghost" aria-hidden="true">
                      {{ secondsLeft | timeFormatGhost }}
                    </span>
                  }

                  <!-- Actual countdown display -->
                  @if (countdown(); as secondsLeft) {
                    <span
                      class="game-score__visible"
                      [ngClass]="{ 'game-score__danger': secondsLeft < 60 }"
                    >
                      {{ secondsLeft | timeFormat }}
                    </span>
                  }
                  @if (isEnded()) {
                    <span>{{ t("countdown-ended") }}</span>
                  }
                </span>
              </div>
              @if (themeService.header().hasPillSubLabel) {
                <div [ngStyle]="scorePillSubLabelStyles | theme">{{ t("countdown") }}</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (themeService.header().hasGameHelpButton) {
    <app-nav-button
      icon="info-circle"
      (clickEvent)="onCheatSheetClicked()"
      class="info-circle-icon"
    />
  }
</div>
